import React, { useContext } from 'react';
import { Edit, Trash2, Search, Activity, FileText, Calendar } from 'lucide-react';
import { formatDateTime, getPriorityColor } from '../utils/otBookingUtils';
import { AuthContext } from '../../../../contexts/AuthContext';

const BookingMobileCards = ({ bookings, onEdit, onDelete, onClearFilters, searchTerm, startDate, endDate }) => {
  const { userRole, permissions } = useContext(AuthContext);
  const hasPermission = (perm) => (userRole || '').toLowerCase() === 'admin' || (permissions || []).includes(perm);
  const showActionsColumn = hasPermission('OT Booking Edit') || hasPermission('OT Booking Delete');

  return (
    <div className="lg:hidden space-y-4">
      {bookings.length === 0 ? (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
          <Search className="h-16 w-16 text-gray-300 mb-4 mx-auto" />
          <h3 className="text-lg font-medium text-gray-500 mb-2">No bookings found</h3>
          <p className="text-gray-400 mb-4">Try adjusting your search criteria</p>
          {(searchTerm || startDate || endDate) && (
            <button
              onClick={onClearFilters}
              className="text-teal-600 hover:text-teal-700 font-medium"
            >
              Clear filters
            </button>
          )}
        </div>
      ) : (
        bookings.map((booking) => {
          const { date, time } = formatDateTime(booking.booking_datetime);
          return (
            <div key={booking.uhid_no} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
              <div className="flex justify-between items-start mb-4">
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 text-lg mb-1">{booking.patient_name}</h3>
                  <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded font-mono text-sm">
                    {booking.uhid_no}
                  </span>
                </div>
                <span className={`px-2 py-1 rounded text-sm font-medium ${getPriorityColor(booking.priority_status)}`}>
                  {booking.priority_status}
                </span>
              </div>
              
              <div className="space-y-3 mb-4">
                <div className="flex items-center gap-3">
                  <Activity className="h-4 w-4 text-gray-400" />
                  <span className="text-gray-900">{booking.type_of_surgery}</span>
                </div>
                <div className="flex items-center gap-3">
                  <FileText className="h-4 w-4 text-gray-400" />
                  <span className="text-gray-600">{booking.surgical_code}</span>
                </div>
                <div className="flex items-center gap-3">
                  <Calendar className="h-4 w-4 text-gray-400" />
                  <span className="text-gray-600">{date} at {time}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="w-4 h-4 bg-blue-100 rounded flex items-center justify-center text-blue-800 text-xs font-bold">R</span>
                  <span className="text-gray-600">{booking.room_no}</span>
                </div>
              </div>

              {showActionsColumn && (
                <div className="flex gap-2 pt-3 border-t border-gray-100">
                  {hasPermission('OT Booking Edit') && (
                    <button 
                      onClick={() => onEdit(booking.uhid_no)} 
                      className="flex-1 flex items-center justify-center gap-2 py-2 px-3 text-blue-600 hover:bg-blue-50 border border-blue-200 rounded-lg transition-colors text-sm font-medium" 
                    >
                      <Edit className="h-4 w-4" />
                      Edit
                    </button>
                  )}
                   
                  {hasPermission('OT Booking Delete') && (
                    <button 
                      onClick={() => onDelete(booking.uhid_no)} 
                      className="flex-1 flex items-center justify-center gap-2 py-2 px-3 text-red-600 hover:bg-red-50 border border-red-200 rounded-lg transition-colors text-sm font-medium" 
                    >
                      <Trash2 className="h-4 w-4" />
                      Delete
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default BookingMobileCards;
